import * as React from "react";
import { TextField } from "react-admin";
import { subResourceList } from "../_subresource";

// GET /patients/{patientId}/stats/health → objet unique, affiché en une
// ligne (détail complet dans le panneau dépliable).
export default {
  list: subResourceList({
    parentParam: "patientId",
    parentLabel: "ID patient",
    children: [
      <TextField key="patientId" source="patientId" label="ID patient" />,
    ],
  }),
};
